import { IStoreOrderConfirmationWidgetData } from "src/typings/store-order-confirmation-widget-data";

export class StoreOrderConfirmationWidgetContentRenderer {

    public createContent(): DocumentFragment {
        const fragment = document.createDocumentFragment();

        const header = this.createHeader();
        const productBlock = this.createProductBlock();

        fragment.append(header, productBlock);
        return fragment;
    }

    private createHeader(): HTMLDivElement {
        const headerWrapper = document.createElement("div");
        headerWrapper.classList.add("header");

        const orderInfoElement = document.createElement("div");
        orderInfoElement.classList.add("order-info");

        const orderNumber = document.createElement("span");
        orderNumber.classList.add("order-number", "main-text");
        orderInfoElement.append(orderNumber);

        headerWrapper.append(orderInfoElement);
        return headerWrapper;
    }

    private createProductBlock(): HTMLDivElement {
        const productBlockWrapper = document.createElement("div");
        productBlockWrapper.classList.add("product");

        const productItems = this.createProductItems();
        const orderPrice = this.createOrderPrice();

        productBlockWrapper.append(productItems, orderPrice);
        return productBlockWrapper;
    }

    public createProductItems(): HTMLElement {
        const productItemsContainer = document.createElement("div");
        productItemsContainer.classList.add("product-items");

        return productItemsContainer;
    }

    public createOrderPrice(): HTMLElement {
        const infoContainer = document.createElement("div");
        infoContainer.classList.add("order-price");

        const itemsLine = this.createItemsLine();
        const paidLine = this.createPaidLine();

        infoContainer.append(itemsLine, paidLine);
        return infoContainer;
    }

    public createItemsLine(): HTMLElement {
        const itemsLine = document.createElement("div");
        itemsLine.classList.add("items-line");

        const items = document.createElement("span");
        items.classList.add("items", "main-text");

        const price = document.createElement("span");
        price.classList.add("price", "main-text");

        const divider = document.createElement("hr");
        divider.classList.add("divider");

        itemsLine.append(items, price, divider);
        return itemsLine;
    }

    public createPaidLine(): HTMLElement {
        const paidLine = document.createElement("div");
        paidLine.classList.add("paid-line");

        const paid = document.createElement("span");
        paid.classList.add("paid", "main-text");

        const price = document.createElement("span");
        price.classList.add("price", "main-text");

        paidLine.append(paid, price);
        return paidLine;
    }

    public renderCustomerInfo(contentElement: HTMLElement | null, data: IStoreOrderConfirmationWidgetData): void {
        if (!contentElement) {
            return;
        }

        contentElement.querySelector(".customer-info")?.remove();

        if (!data.displayBillingAddress && !data.displayPaymentMethod) {
            return;
        }

        const customerInfo = document.createElement("div");
        customerInfo.classList.add("customer-info");

        if (data.displayBillingAddress) {
            customerInfo.append(this.createBillingAddress());
        }

        if (data.displayPaymentMethod) {
            customerInfo.append(this.createPaymentMethod());
        }

        contentElement.append(customerInfo);
    }

    private createBillingAddress(): HTMLElement {
        const billingAddress = document.createElement("div");
        billingAddress.classList.add("billing-address");

        const title = document.createElement("span");
        title.classList.add("title", "main-text");

        const address = document.createElement("span");
        address.classList.add("address", "main-text");

        billingAddress.append(title, address);
        return billingAddress;
    }

    private createPaymentMethod(): HTMLElement {
        const billingAddress = document.createElement("div");
        billingAddress.classList.add("payment-method");

        const title = document.createElement("span");
        title.classList.add("title", "main-text");

        const address = document.createElement("span");
        address.classList.add("payment", "main-text");

        billingAddress.append(title, address);
        return billingAddress;
    }

}
